// extracted by mini-css-extract-plugin
export default {"dropzone":"YORgjY0rFo_Uu0mcZDog"};